import React, { useState } from 'react';
import classNames from 'classnames/bind';

import { Button } from '@components';
import { Typography } from 'gd-design-library';

import styles from './LoadMoreButton.module.scss';

const CN = 'load-more-button';
const textClassName = `${CN}--text`;
const cx = classNames.bind(styles);

interface LoadMoreButtonProps {
  className?: string;
  currentCount: number;
  total: number;
  onClick: () => Promise<unknown>;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  currentCount,
  total,
  onClick,
  className
}) => {
  const [ isNewDataLoading, setIsNewDataLoading ] = useState(false);

  const handleClick = (): void => {
    setIsNewDataLoading(true);
    onClick().finally(() => setIsNewDataLoading(false));
  };

  return (
    <div className={ cx(CN, className) }>
      {currentCount < total && (
        <Button
          onClick={ handleClick }
          loading={ isNewDataLoading }
        >
          Load More
        </Button>
      )}
      <Typography variant='h6' className={ cx(textClassName) }>
        {`Viewing ${currentCount} out of ${total} items`}
      </Typography>
    </div>
  );
};
